// extracted by mini-css-extract-plugin
export var news = "styles-module--news--1yzPU";
export var news_txt_title = "styles-module--news_txt_title--_dGLp";
export var news_image_inner = "styles-module--news_image_inner--1xTm6";
export var news_image = "styles-module--news_image--3lwQv";
export var news_txt = "styles-module--news_txt--3RA-u";
export var news_txt_date = "styles-module--news_txt_date--3dmG4";